module.exports = __webpack_public_path__ + "static/logo-web-d6f27c91c6949ff137b23399e03f11ce.png";